var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',[_c('img',{attrs:{"src":"images/banner_support.jpg"}}),_c('div',{staticClass:"m1",on:{"click":function($event){return _vm.gotosupport()}}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }